import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import * as API from "../../Endpoints/Endpoints"; // Ensure endpoints are correctly defined here

const ViewAllocation = () => {
  const [allocationData, setAllocationData] = useState(null); // Default to `null` for clarity
  const { cardallocid } = useParams();
  const navigate = useNavigate();

  // Fetch allocation data
  useEffect(() => {
    const getAllocationData = async () => {
      try {
        const response = await axios.get(API.GET_ALLOCATION_BYID(cardallocid));
        setAllocationData(response.data); // Adjust depending on the actual response structure
      } catch (error) {
        console.error("Error fetching allocation data:", error);
      }
    };

    if (cardallocid) {
      getAllocationData();
    }
  }, [cardallocid]);

  // Handle allocation deletion
  const deleteAllocation = async (cardallocid) => {
    if (!window.confirm("Are you sure you want to delete this allocation?")) return;
    try {
      await axios.delete(API.DELETE_ALLOCATION_API(cardallocid));
      alert("Allocation deleted successfully");
      navigate("/allocationtable");
    } catch (error) {
      console.error("Error deleting allocation:", error.response?.data || error.message);
      alert("Failed to delete allocation");
    }
  };

  // Navigate back to allocation table
  const goBack = () => {
    navigate("/cardalloctable");
  };

  return (
    <div className="py-16 bg-[#f5f5f5] h-full">
      <div className="container px-6 m-auto text-gray-700 md:px-12 xl:px-0">
        <div className="grid gap-6 mx-auto md:w-3/6 lg:w-full lg:grid-cols-1">
          <div className="bg-white rounded-2xl shadow-lg px-8 py-12 sm:px-12 lg:px-8">
            <div className="mb-12 space-y-6">
              {allocationData ? (
                <div>
                  <h5 className="text-2xl font-semibold text-[#e64a32]">
                    Allocation Details
                  </h5>
                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                    <div className="flex flex-col">
                      <span className="font-bold">Game Category</span>
                      <span>{allocationData.gamecategory || "N/A"}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Game Name</span>
                      <span>{allocationData.gamename || "N/A"}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Card Group</span>
                      <span>{allocationData.cardgroup || "N/A"}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Card Name</span>
                      <span>{allocationData.cardname || "N/A"}</span>
                    </div>
                  </div>
                  <div className="flex items-center justify-center mt-6 space-x-4">
                    <button
                      className="bg-[#e64a32] text-white hover:bg-[#c5382e] font-bold py-2 px-4 rounded"
                      onClick={() => deleteAllocation(allocationData.cardallocid)}
                    >
                      Delete
                    </button>
                    <button
                      className="bg-[#e64a32] hover:bg-[#c5382e] text-white font-bold py-2 px-4 rounded"
                      onClick={goBack}
                    >
                      &#8592; Go Back
                    </button>
                  </div>
                </div>
              ) : (
                <p className="text-center text-gray-500">Loading allocation details...</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewAllocation;
